<template>
	<div>
		<HeadNav selectedLanguage="en" page="gb" :gotodownload="gotodownload" :apk="apk" />
		<div class="banner">
			<my-img src='1' alt='logo' size="s" />
			<div class="title">
				GB WhatsApp
			</div>
			<div class="desc">
				Welcome to our website! Get the latest GBWhatsApp and GB WhatsApp Pro APK for Android and unlock the
				ultimate WhatsApp experience. Enjoy advanced privacy controls, custom themes, anti-ban protection,
				and powerful features you won’t find in the standard app. Don’t wait—download now and take your
				chats to the next level!
			</div>
			<div class="b">
				<div class="label">Version:</div>
				<div class="c">V18.80 </div>
				<div class="label">&nbsp; Size:</div>
				<div class="c">65MB </div>
			</div>
			<DownloadBtn value="Download APK" mg="2" />
		</div>
		<div class="main-wrapper">

			<article>
				<hh1>GB WhatsApp APK Download New Version</hh1>

				<p>Instant messaging has become a key part of everyday life, and few apps are as widely used as WhatsApp. Compared to WhatsApp’s basic layout and standard features, <strong><a href="/" class="jump-url">GB WhatsApp</a></strong> provide users with advanced privacy controls, customizable themes, and powerful settings.</p>

				<p>Our website collect <strong><a href="/" class="jump-url">GBWhatsApp</a></strong> info and share the background, popular mod features, apk installation guide for you. You can also check the difference of GB WhatsApp Pro and WhatsApp, which helps you to decide if it worth trying. Now, let's start.</p>

				<nav class="home-toc" :class="{ 'is-open': showTableOfContents }" aria-label="Table of Contents">
  <button
    type="button"
    class="home-toc-toggle"
    :aria-expanded="showTableOfContents ? 'true' : 'false'"
    aria-controls="home-toc-list"
    @click="toggleTableOfContents"
  >
    <span class="home-toc-title">Table of Contents</span>
    <span class="home-toc-icon" aria-hidden="true">{{ showTableOfContents ? '−' : '+' }}</span>
  </button>
  <ol v-show="showTableOfContents" id="home-toc-list">
    <li v-for="item in tocItems" :key="item.id">
      <a :href="'#' + item.id" @click.prevent="scrollToHeading(item.id)">{{ item.text }}</a>
    </li>
  </ol>
</nav>
<hh2 id="what-is-gb-whatsapp">What is GB WhatsApp?</hh2>

				<p>GB WhatsApp is a powerful modified version of the standard WhatsApp, developed by some different teams including Alexmods, Heymods, <a href="https://androidwaves.org/gb-whatsapp-apk/" target="_blank" rel="nofollow" class="jump-url">androidwave</a> and others. You may wonder why people choose to use GB WhatsApp.</p>

				<p>That's because this app let you run multiple accounts simultaneously, customize themes, fonts, and chat backgrounds, and schedule messages for later. Mod features help users take full control of the messaging experience. Read on to continue exploring this app.</p>

				<table class="app-info-table">
					<tr>
						<td><strong>App Name</strong></td>
						<td>GB WhatsApp</td>
					</tr>
					<tr>
						<td><strong>Size</strong></td>
						<td>65MB</td>
					</tr>
					<tr>
						<td><strong>Version</strong></td>
						<td>V18.80</td>
					</tr>
					<tr>
						<td><strong>Developer</strong></td>
						<td>Alexmods</td>
					</tr>
					<tr>
						<td><strong>Cateogory</strong></td>
						<td>Mod app</td>
					</tr>
				</table>

				<hh2 id="rich-features-of-gb-whatsapp"><strong>Rich Features of GB WhatsApp</strong></hh2>

				<p>This comprehensive guide explores the key features of GBWhatsApp, its benefits, and the potential
					risks associated with using a modded application.</p>

<hh3><strong>Hide Online Status</strong></hh3>

				<p>One of GBWhatsApp’s most appreciated features is the ability to hide your online status. With
					GBWhatsApp, users can chat freely without appearing “online” to others. This is ideal for those who
					want to use WhatsApp without the pressure of instantly replying to messages.</p>

				<my-img src='2' alt='Hide Online Status' />

				<hh3><strong>Auto Reply</strong></hh3>

				<p>GB WhatsApp's auto-reply functionality <strong>enables you to type out</strong>
					<strong>preset</strong> <strong>replies for messages that arrive</strong>. This is particularly
					handy for business accounts or when you're going offline momentarily.
				</p>

				<my-img src='3' alt='Auto Reply' />

				<hh3><strong>DND Mode (Do Not Disturb)</strong></hh3>

				<p>With GBWhatsApp’s DND mode, you can disable all WhatsApp notifications and activity while still using
					your device for other purposes. This is perfect when you need focused work time or uninterrupted
					sleep.</p>

				<my-img src='4' alt='DND Mode ' />

				<ol>
					<li><strong>Multiple Account Support</strong> GBWhatsApp allows you to run two, three, or even more
						accounts on a single device without relying on parallel-space apps or messy workarounds. Perfect
						for separating work, personal, and business accounts seamlessly.</li>
					<li><strong>Custom Themes and</strong> <strong>UI</strong> <strong>Tweaks</strong> With GBWhatsApp,
						you get access to hundreds of fan-made themes and full control over fonts, colors, chat bubbles,
						and icons. Personalize your chat window to reflect your style or mood instantly.</li>
					<li><strong>Enhanced Privacy Controls</strong> Hide your online status, typing indicators, blue
						ticks, and recording notifications. GBWhatsApp also lets you control who sees your last seen,
						forwarded messages, and status updates, giving you ultimate discretion in conversations.</li>
					<li><strong>Share Large Files</strong> Send videos up to 100 MB, high-resolution images without
						compression, and messages to up to 250 contacts at once. GBWhatsApp removes the frustrating
						limitations of the official app, making media sharing smoother and faster.</li>
					<li><strong>Automated Replies & Scheduled Messages</strong> GBWhatsApp includes chat automation
						similar to WhatsApp Business. Set auto-replies when you’re busy, or schedule messages to send at
						the perfect time, ensuring nothing is missed.</li>
					<li><strong>View Deleted Messages</strong> No more wondering what someone deleted. GBWhatsApp keeps
						a copy of all messages, allowing you to read texts even after they’ve been unsent.</li>
					<li><strong>Extended Status & Easy Downloads</strong> Share longer videos in your status updates and
						save friends’ status photos and clips directly to your gallery without needing third-party
						tools.</li>
					<li><strong>In-App Lock & Enhanced Security</strong> Protect your chats with a PIN, pattern,
						fingerprint, or face scan. GBWhatsApp’s built-in app lock keeps sensitive conversations safe,
						even if someone else uses your phone.</li>
					<li><strong>Advanced Media Preview</strong> *(Additional Feature)* Preview images and videos
						directly from notifications without opening the app, saving time and avoiding unnecessary app
						launches.</li>
					<li><strong>Anti-Ban & Regular Updates</strong> *(Additional Feature)* GBWhatsApp regularly updates
						with anti-ban features, bug fixes, and new tools, ensuring you stay secure while enjoying the
						latest functionalities.</li>
</ol>

<hh2 id="how-to-download-gb-whatsapp-new-version-step-by-step"><strong>How to Download GB WhatsApp New Version Step By Step</strong></hh2>

				<p>Since GB WhatsApp Pro isn’t available on the Play Store, you’ll need to get the APK via a trusted
					source. Follow these steps for a safe <strong>GB WhatsApp Download</strong>:</p>

				<my-img src='5' alt='Download GB WhatsApp' type="heng" />

				<hh3><strong>Step 1: Backup Your WhatsApp Data</strong></hh3>

				<p> Before switching, back up your chats in the official WhatsApp app to ensure no messages or media are
					lost during the transition.</p>

				<hh3><strong>Step 2: Enable Unknown Sources</strong></hh3>

				<p> Go to <strong>Settings &gt; Security</strong> and turn on <strong>Unknown Sources</strong>. This
					allows your device to install apps from APK files instead of the Play Store.</p>

				<hh3><strong>Step 3: Perform GB WhatsApp Download</strong></hh3>

				<p> Visit our official website or another reliable platform to download the latest version of GB
					WhatsApp Pro safely.</p>

				<hh3><strong>Step 4: Install the APK</strong></hh3>

				<p>Locate the downloaded APK file, tap on it, and select <strong>Install</strong>. Wait for the
					installation to complete — a notification will confirm once it’s ready.</p>

				<hh3><strong>Step 5: Verify Your Phone Number</strong></hh3>

				<p> Open GB WhatsApp Pro, enter your phone number, and input the verification code sent via SMS. This
					will activate your account quickly and securely.</p>

				<hh3><strong>Step 6: Restore Your Chats</strong></hh3>

				<p>If you created a backup in Step 1, the app will prompt you to restore your messages. Confirm, and all
					your previous conversations will reappear, ready to continue seamlessly.</p>

				<hh2 id="requirements-to-install-gb-whatsapp"><strong>Requirements to Install GB WhatsApp</strong></hh2>

<table class="content-table requirements-table">
  <thead>
    <tr>
      <th>Requirement</th>
      <th>Details</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Operating System</td>
      <td>Android 5.0 (Lollipop) or higher. There is currently no official iOS version.</td>
    </tr>
    <tr>
      <td>Storage</td>
      <td>At least 100 MB of free space for the APK and basic app data. More space is recommended for media files.</td>
    </tr>
    <tr>
      <td>RAM</td>
      <td>2 GB or more is recommended for smoother performance. Lower RAM may still work but could cause lag.</td>
    </tr>
    <tr>
      <td>Internet Connection</td>
      <td>Required for messaging, media sharing, calls, and app updates.</td>
    </tr>
    <tr>
      <td>Permissions</td>
      <td>May require access to Storage, Contacts, Camera, Microphone, and optionally Location for certain features.</td>
    </tr>
    <tr>
      <td>Windows &amp; macOS</td>
      <td>Can be used on a computer through an Android emulator.</td>
    </tr>
  </tbody>
</table>

<hh2 id="gb-whatsapp-pro-vs-whatsapp"><strong>GB WhatsApp Pro VS WhatsApp: What's the Difference?</strong></hh2>

<table class="content-table comparison-table">
  <thead>
    <tr>
      <th>Feature</th>
      <th>WhatsApp Official</th>
      <th>GB WhatsApp Pro</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Custom Themes</td>
      <td>No</td>
      <td>Yes (Thousands available)</td>
    </tr>
    <tr>
      <td>Multiple Accounts</td>
      <td>No (requires Dual Apps)</td>
      <td>Yes (built-in support)</td>
    </tr>
    <tr>
      <td>Message Scheduling</td>
      <td>No</td>
      <td>Yes</td>
    </tr>
    <tr>
      <td>Auto-Reply</td>
      <td>Yes (Business only)</td>
      <td>Yes</td>
    </tr>
    <tr>
      <td>Hide Last Seen</td>
      <td>Yes (on/off for all)</td>
      <td>Yes (selective contact-based)</td>
    </tr>
    <tr>
      <td>Anti-Revoke Messages</td>
      <td>No</td>
      <td>Yes</td>
    </tr>
    <tr>
      <td>Maximum Media Size Sharing</td>
      <td>16 MB (video)</td>
      <td>Up to 100 MB</td>
    </tr>
    <tr>
      <td>File Sharing Types</td>
      <td>Basic (images, videos, docs)</td>
      <td>Expanded formats supported</td>
    </tr>
    <tr>
      <td>Chat Backup Support</td>
      <td>Google Drive, iCloud</td>
      <td>Google Drive + local encrypted backups</td>
    </tr>
    <tr>
      <td>Risk of Ban</td>
      <td>Official app, fully safe</td>
      <td>Moderate (anti-ban features but mod risks exist)</td>
    </tr>
  </tbody>
</table>

<hh2 id="how-to-update-gb-whatsapp-and-always-keep-it-updated"><strong>How to Update GB WhatsApp and Always Keep It Updated</strong></hh2>

<p>Keeping GB WhatsApp updated can help you get the latest features and fixes. You can bookmark <strong>gbappze.com</strong> and check for the newest version, or look for an update notice inside the app.</p>
<p>To update GBWhatsApp, download the latest APK from a trusted source and install it over your current version. In most cases, your existing chats and settings will remain on your device, but <strong>backing up your chats before updating is always recommended</strong>.</p>
<p>Since GBWhatsApp is not available on Google Play, avoid unknown app stores or download pages with suspicious pop-ups and redirects. Stick to a reliable source and make sure you are downloading the correct APK version.</p>

<hh3>Backing Up Your Chats</hh3>
<p>Before updating or reinstalling GB WhatsApp APK, it's a good idea to create a backup. Go to <strong>Settings &gt; Chats &gt; Backup</strong> and follow the available backup options.</p>

<p>If you need to reinstall the app or switch to another phone, you can use the <a href="https://gbappze.com/backup-gbwhatsapp-chats-to-google-drive/" class="jump-url">backup to restore your chats</a> when supported. Keep in mind that backups may not always be compatible between GB WhatsApp APK and the official WhatsApp app.</p>

<hh2 id="why-people-choose-gb-whatsapp-old-version"><strong>Why People Choose GB WhatsApp Old Version?</strong></hh2>

<p>Some users prefer a <a href="https://gbappze.com/gb-whatsapp-old-versions/" class="jump-url">GB WhatsApp old version</a> app because it worked better on their phone or included features they are familiar with.</p>

<ul>
  <li><strong>Better Stability</strong> - Return to a version that worked reliably on your device.</li>
  <li><strong>Fewer New Bugs</strong> - Avoid problems that may appear after a major update.</li>
  <li><strong>Better Compatibility</strong> - Older versions may work better on some Android devices.</li>
  <li><strong>Preferred Features</strong> - Keep features or settings that changed in newer versions.</li>
  <li><strong>Login &amp; <a href="https://gbappze.com/gbwhatsapp-banned-problem-fix/" class="jump-url">Ban Issues</a></strong> - Some users look for an earlier version after experiencing login or account restrictions.</li>
  <li><strong>Familiar Experience</strong> - Keep using a version with the interface and settings you already know.</li>
</ul>

<hh2 id="about-gb-whatsapp-ban-issue">About GB WhatsApp Ban Issue</hh2>
				<p>GB WhatsApp is a modified version of the official WhatsApp, which means it doesn’t follow WhatsApp’s official policies. Because of this, <strong>there is always a risk of account bans</strong> when using GB WhatsApp.</p>

				<p>In recent years, WhatsApp has increased its detection of modded apps. Users may receive:</p>

				<ul>
				<li>A <strong>temporary ban</strong> (usually a warning or short suspension), or</li>
				<li>A <strong>permanent ban</strong> in more serious or repeated cases</li>
				</ul>

				<p>To reduce the risk, it’s best not to use GB WhatsApp with your main phone number. And you should avoid enabling extreme or suspicious features such as mass messaging. Always keep the app updated from a trusted source to avoid being banned one day. If privacy and long-term account safety matter more to you, the official WhatsApp remains the safest option.</p>

				<hh2 id="how-to-use-gb-whatsapp-and-whatsapp-on-the-same-phone">How to Use GB WhatsApp and WhatsApp on the Same Phone?</hh2>

				<p>A large number of users choose GB WhatsApp as a clone app of WhatsApp, here we introduce how it works:</p>

				<hh3>Method 1: Use a Second Phone Number</hh3>

				<ul>
				<li>Install <strong>official WhatsApp</strong> and register it with your main number</li>
				<li>Install <strong>GB WhatsApp</strong> and register it with a different phone number</li>
				<li>This is the <strong>safest and most common method</strong></li>
				</ul>

				<hh3>Method 2: Use GB WhatsApp as a Linked Device</hh3>

				<p>Some versions allow you to link GB WhatsApp as a companion device:</p>

				<ul>
				<li>Open GB WhatsApp</li>
				<li>Choose the “Link a device” or “Use as companion” option</li>
				<li>Scan the QR code using your official WhatsApp</li>
				</ul>

				<p>This method avoids registering a second number, but it may stop working after updates and is <strong>less stable</strong>.</p>

				<hh3>Switching from Official WhatsApp</hh3> 
				<p>Transitioning from the stock WhatsApp to GB
					WhatsApp Pro is straightforward. First, back up all chats in your original app. Many users choose to
					uninstall the official version to avoid conflicts, though it isn’t mandatory.</p>

				<p>Next, install the GB WhatsApp Pro APK following the previous steps. When prompted, restore your
					backup, and confirm your phone number. That’s it—you’re ready to enjoy all the mod’s enhanced
					features.</p>

				<hh2 id="pros-and-cons-of-using-gb-whatsapp">
  <strong>Pros and Cons of Using GB WhatsApp</strong>
</hh2>

<table class="content-table pros-cons-table">
  <thead>
    <tr>
      <th>Pros</th>
      <th>Cons</th>
    </tr>
  </thead>
  <tbody>
    <tr><td>More privacy controls</td><td>Unofficial app</td></tr>
    <tr><td>More customization</td><td>Ban risk</td></tr>
    <tr><td>Multiple accounts</td><td>Manual updates</td></tr>
    <tr><td>Larger file sharing</td><td>Security concerns</td></tr>
    <tr><td>Extra messaging tools</td><td>Less stable</td></tr>
    <tr><td>More chat controls</td><td>Limited official support</td></tr>
    <tr><td>More media options</td><td>More maintenance required</td></tr>
    <tr><td>More advanced features</td><td></td></tr>
  </tbody>
</table>

<hh2 id="conclusion"><strong>Conclusion</strong></hh2>

				<p>GB WhatsApp Pro stands out as one of the most feature-packed WhatsApp mods available for Android,
					offering unmatched customization, enhanced privacy controls, and productivity tools that the
					official app simply doesn’t provide. While it delivers these powerful benefits, users should remain
					mindful of potential risks such as account suspension or security vulnerabilities. </p>

				<p>To enjoy GB WhatsApp Pro safely, always download the APK from a verified source, regularly back up
					your chats, and stay updated with the latest releases. For those seeking extra control, flexibility,
					and personalization in their messaging, the advantages of GB WhatsApp Pro far outweigh its
					limitations—making it a top choice for power users.</p>

				<hh2 id="faqs"><strong>FAQs</strong></hh2>

<div class="home-faq">
  <FAQ :faqs="faqs" :default-open="0" />
</div>

			</article>



		</div>

		<DownloadBtn style="position: fixed;bottom: 10px;transform: translateX(-50%);left: 50%;"
			value="Download GB WhatsApp APK" v-if="$global.isMobileDevice()" />
	</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import HeadNav from '@/components/HeadNav.vue'
import MyImg from '../components/MyImg.vue'
import DownloadBtn from '../components/DownloadBtn.vue'
import FAQ from '@/components/FAQ.vue'
export default {
	name: 'Home',
	components: {
		HeadNav,
		DownloadBtn,
		MyImg,
		FAQ,
	},
	data() {
		return {
			pageName: 'home',
			tableHide: true,
			comment: {
				name: '',
				email: '',
				content: '',
			},
			showapk: false,
			showTableOfContents: false,
tocItems: [
        { id: 'what-is-gb-whatsapp', text: 'What is GB WhatsApp?' },
        { id: 'rich-features-of-gb-whatsapp', text: 'Rich Features of GB WhatsApp' },
        { id: 'how-to-download-gb-whatsapp-new-version-step-by-step', text: 'How to Download GB WhatsApp New Version Step By Step' },
        { id: 'requirements-to-install-gb-whatsapp', text: 'Requirements to Install GB WhatsApp' },
        { id: 'gb-whatsapp-pro-vs-whatsapp', text: "GB WhatsApp Pro VS WhatsApp: What's the Difference?" },
        { id: 'how-to-update-gb-whatsapp-and-always-keep-it-updated', text: 'How to Update GB WhatsApp and Always Keep It Updated' },
        { id: 'why-people-choose-gb-whatsapp-old-version', text: 'Why People Choose GB WhatsApp Old Version?' },
        { id: 'about-gb-whatsapp-ban-issue', text: 'About GB WhatsApp Ban Issue' },
        { id: 'how-to-use-gb-whatsapp-and-whatsapp-on-the-same-phone', text: 'How to Use GB WhatsApp and WhatsApp on the Same Phone?' },
        { id: 'pros-and-cons-of-using-gb-whatsapp', text: 'Pros and Cons of Using GB WhatsApp' },
        { id: 'conclusion', text: 'Conclusion' },
        { id: 'faqs', text: 'FAQs' }
      ],
faqs: [
        {
          question: 'Can I see deleted messages on GB WhatsApp?',
          answer: 'Yes! GB WhatsApp lets you view messages even after the sender has deleted them, so nothing important slips away.'
        },
        {
          question: 'Can I use multiple accounts on GB WhatsApp?',
          answer: 'Absolutely. GB WhatsApp supports multiple accounts on the same device, making it easy to separate work and personal chats.'
        },
        {
          question: 'Can I run GB WhatsApp Pro alongside the official WhatsApp?',
          answer: 'Yes, you can use both apps on one device without conflicts, allowing you to switch between them smoothly.'
        },
        {
          question: 'Is there a risk of getting banned from WhatsApp?',
          answer: 'Using any modded app carries some risk. GB WhatsApp frequently updates its anti-ban features, which lowers the chance of account suspension.'
        },
        {
          question: 'Can I use GB WhatsApp Pro on an iPhone?',
          answer: 'Currently, GB WhatsApp Pro is only available for Android devices. iPhone users can only use the official WhatsApp for now.'
        },
        {
          question: 'Is GB WhatsApp Pro safe?',
          answer: 'While it includes anti-ban protections and maintains end-to-end encryption like the official app, it is still a third-party mod. Always download from trusted sources and keep backups to minimize risks.'
        },
        {
          question: 'How can I recover chats after uninstalling?',
          answer: 'Before uninstalling, make a manual backup. You can restore your chats from that backup when reinstalling, keeping all messages intact.'
        },
        {
          question: 'How often does GB WhatsApp Pro get updated?',
          answer: 'The developers release updates every few weeks or months, often aligned with official WhatsApp changes. Updates improve security and add new features to keep the app fresh.'
        }
      ],

			apk: null,
			from: 'gb',
			filename: 'gb',
			clickNum: 0,
			selectedLanguage: 'en',
			lang: [
				{
					lang: 'en',
					val: '🇺🇸 English',
				},
				{
					lang: 'ar',
					val: '🇦🇪 اَلْعَرَبِيَّةُ',
				},
				{
					lang: 'id',
					val: '🇮🇩 Bahasa Indonesia',
				},
				{
					lang: 'pt',
					val: '🇵🇹 Português',
				},
				{
					lang: 'es',
					val: '🇪🇸 Español',
				},
				{
					lang: 'hi',
					val: '🇮🇳 हिंदी',
				},
			],

			androidSrc: require('@/assets/android.svg'),
			androidSrc2: require('@/assets/android.svg'),

		}
	},
	computed: {
		downloadURL() {
			// var params = window.location.search;
			// return `/gbwhatsapp-apk-download${params}`;
			if (typeof window === 'undefined') {
				// Server-side rendering logic
				return '/gbwhatsapp-apk-download' // Adjust this based on your server-side logic
			} else {
				// Client-side rendering logic
				let params = window.location.search
				return `/gbwhatsapp-apk-download${params}`
			}
		},
	},
	mounted() {
		this.from = this.$global.GetQueryString('from') || this.from
		this.filename = this.$global.GetQueryString('filename') || this.filename
		console.log(this.$global.GetQueryString('from'))
		if (this.$global.GetQueryString('from')) {
			this.getAPK()
		} else {
			this.getOfficalApk()
		}



		// window.adsTag.renderInterstitial(54982);
	},
	methods: {
		changeImage(newImage) {
			this.androidSrc = require(`@/assets/${newImage}`)
		},
		changeImage2(newImage) {
			this.androidSrc2 = require(`@/assets/${newImage}`)
		},
		changeLanguage(lang) {
			console.log(lang)
			// 处理语言选择变化
			// 这里可以添加其他处理逻辑，例如将语言保存到cookie或localStorage中
			this.$router.push({
				name: `${this.selectedLanguage}-gb`,
			})
		},
		downloadClick() {
			this.$router.push({
				name: 'en-download',
			})
		},
		getAPK() {
			this.$server
				.getAPPInfo({
					promotionChannel: this.from,
					promotionName: this.filename,
				})
				.then((res) => {
					console.log(res)
					if (res.code == 200) {
						this.apk = res.data.apk
					} else {
						this.apk = process.env.VUE_APP_GBLINK
					}
				})
				.catch(() => {
					this.apk = process.env.VUE_APP_GBLINK
				})
		},
		getOfficalApk(type = 1, domain = null, appname = null) {
			this.$server
				.getOfficalApk({
					domain: domain || 'gbwhatsapp.chat',
					appName: appname || 'GB_gbwhatsapp.chat',
				})
				.then((res) => {
					console.log(res)
					if (res.code == 200) {
						if (type == 1) {
							this.apk = res.data.apk
						}
						this.lastupdate = res.data.promotion.updateTime
						this.votes = res.data.promotion.totalCount
						this.rating = res.data.promotion.score
						console.log('apk getted')
					} else {
						this.apk = process.env.VUE_APP_GBLINK
					}
				})
				.catch(() => {
					this.apk = process.env.VUE_APP_GBLINK
				})
		},
		gotodownload() {
			this.$router.push('/download-apk')
		},
		gotoblog() {
			window.location.href = '/blogs'
		},
		jump(url) {
			window.location.href = url
		},
		toggleTableOfContents() {
			this.showTableOfContents = !this.showTableOfContents
		},
		scrollToHeading(id) {
			if (typeof window === 'undefined') return
			const element = document.getElementById(id)
			if (!element) return
			element.scrollIntoView({ behavior: 'smooth', block: 'start' })
		},
		initSwiper() {
			new Swiper('.swiper-container', {
				slidesPerView: 1,
				spaceBetween: 30,
				loop: true,
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 30,
					},
				},
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.banner {
	display: flex;
	flex-direction: column;
	padding: 20px 40px;
	justify-content: center;
	align-items: center;
	background: linear-gradient(150deg, #1e3c72, #2a5298);

	.title {
		font-size: 32px;
		line-height: 46px;
		text-align: center;
		color: white;
		font-weight: 900;
	}

	.desc {
		width: 70vw;
		margin-top: 15px;
		color: white;
		font-size: large;
		font-weight: 500;
	}

	.b {
		display: flex;
		display: flex;
		flex-direction: row;
		align-items: baseline;
		color: white;
		margin-top: 20px;

		.c {
			font-weight: 900;
			font-size: 23px;
		}
	}

}

.app-info-table {
	width: 100%;
	max-width: 600px;
	margin: 20px auto;
	border-collapse: collapse;
	border-radius: 12px;
	overflow: hidden;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
	background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);

	tr {
		transition: all 0.3s ease;

		&:nth-child(even) {
			background: linear-gradient(135deg, #f8f9ff 0%, #e6f3ff 100%);
		}

		&:nth-child(odd) {
			background: linear-gradient(135deg, #ffffff 0%, #f1f3f4 100%);
		}

		&:hover {
			background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
			transform: translateY(-2px);
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		}

		td {
			padding: 16px 20px;
			border-bottom: 1px solid #e0e0e0;
			font-size: 16px;
			color: #333;

			&:first-child {
				font-weight: 600;
				color: #1976d2;
				background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
				min-width: 120px;
			}

			&:last-child {
				font-weight: 500;
				color: #424242;
			}
		}

		&:last-child td {
			border-bottom: none;
		}
	}
}

.home-toc {
  margin: 28px auto 32px;
  padding: 12px 20px;
  max-width: 100%;
  border: 1px solid #dfe9f5;
  border-left: 4px solid #1976d2;
  border-radius: 12px;
  background: #f8fbff;
  box-shadow: 0 12px 30px rgba(25, 118, 210, 0.08);

  &.is-open {
    padding: 16px 24px 20px;
  }

  .home-toc-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 0;
    padding: 4px 0;
    border: 0;
    background: transparent;
    cursor: pointer;
    font: inherit;
    color: inherit;
    text-align: left;

    &:hover .home-toc-icon {
      border-color: #1976d2;
      background: #eaf3ff;
    }
  }

  .home-toc-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.3;
    color: #183a56;
  }

  .home-toc-icon {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    margin-left: 12px;
    border: 1px solid #b9d2ec;
    border-radius: 6px;
    background: #fff;
    color: #1976d2;
    font-size: 22px;
    font-weight: 700;
    line-height: 26px;
    text-align: center;
  }

  ol {
    margin: 14px 0 0;
    padding-left: 22px;

    li {
      margin: 0 0 9px;
      break-inside: avoid;
      line-height: 1.45;

      &::marker {
        color: #1976d2;
        font-weight: 700;
      }

      a {
        display: inline-block;
        color: #245c82;
        text-decoration: none;
        transition: color 0.2s ease, transform 0.2s ease;

        &:hover {
          color: #0d6efd;
          transform: translateX(2px);
          text-decoration: underline;
          text-underline-offset: 3px;
        }
      }
    }
  }
}

.content-table {
  width: 100%;
  margin: 24px 0;
  border: 1px solid #dfe5ee;
  border-radius: 12px;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 10px 24px rgba(27, 54, 93, 0.07);

  th,
  td {
    padding: 14px 16px;
    border-right: 1px solid #e1e8f0;
    border-bottom: 1px solid #e1e8f0;
    vertical-align: top;
    text-align: left;
    font-size: 16px;
    line-height: 1.55;
    color: #3c4652;
  }

  th {
    background: #eef5ff;
    font-weight: 700;
    color: #173a5e;
  }

  th:last-child,
  td:last-child {
    border-right: 0;
  }

  tbody tr:last-child td {
    border-bottom: 0;
  }

  tbody tr:nth-child(even) {
    background: #fbfdff;
  }

  tbody tr:hover {
    background: #f2f8ff;
  }
}

.requirements-table {
  td:first-child {
    width: 190px;
    background: #f6faff;
    font-weight: 600;
    color: #184c78;
  }
}

.comparison-table {
  th:nth-child(1),
  td:nth-child(1) {
    min-width: 150px;
    background: #f7f9fc;
    font-weight: 600;
    color: #28445f;
  }

  th:first-child {
    background: #eef5ff;
    color: #173a5e;
  }
}

.pros-cons-table {
  th:first-child {
    background: #e9f7ef;
    color: #17633a;
  }

  th:last-child {
    background: #fff0ef;
    color: #9b3530;
  }

  td:first-child {
    background: #f6fbf8;
    color: #17633a;
    font-weight: 600;
  }

  td:last-child {
    background: #fffaf9;
    color: #9b3530;
  }
}

article a {
  color: #1a5881;

  &:hover,
  &:focus,
  &:active {
    color: #0d47a1;
  }
}

.home-faq {
  max-width: 100%;
  margin: 8px auto 48px;
  text-align: left;

  ::v-deep .faq {
    display: grid;
    gap: 12px;
    padding: 0;
  }

  ::v-deep .faq .dropdown-faq {
    overflow: hidden;
    border: 1px solid #dce5f0;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(27, 54, 93, 0.05);
    cursor: pointer;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

    &:hover {
      border-color: #b9d2ec;
      box-shadow: 0 10px 24px rgba(27, 54, 93, 0.08);
    }

    &.active {
      border-color: #1976d2;
      box-shadow: 0 12px 26px rgba(25, 118, 210, 0.12);
    }
  }

  ::v-deep .faq .faq-title {
    padding: 16px 18px;
    font-size: 17px;
    font-weight: 600;
    line-height: 1.45;
    color: #183a56;

    img {
      width: 18px;
      height: 18px;
      margin: 0;
      opacity: 0.72;
    }

    &.active {
      color: #0b5ed7;
    }
  }

  ::v-deep .faq .content {
    margin: 0;
    padding: 14px 18px 18px;
    border-top: 1px solid #edf2f7;
    font-size: 16px;
    line-height: 1.75;
    color: #4b5563;
  }
}

@media (max-width: 768px) {
  .home-toc {
    max-width: 100%;
    padding: 10px 16px;

    &.is-open {
      padding: 12px 16px 16px;
    }

    .home-toc-title {
      font-size: 18px;
    }

    ol {
      column-count: 1;
    }
  }

  .content-table {
    display: table;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    table-layout: fixed;

    th,
    td {
      padding: 10px 8px;
      font-size: 14px;
      word-break: break-word;
      overflow-wrap: anywhere;
    }
  }

  .home-faq {
    max-width: 100%;

    ::v-deep .faq .faq-title {
      padding: 14px 16px;
      font-size: 16px;
    }

    ::v-deep .faq .content {
      padding: 12px 16px 16px;
      font-size: 15px;
    }
  }
}

</style>
